<template>
    <div class="container">
        <div class="container">
            <div class="top">
                <div class="title">
                    兑换账户
                </div>
                <div @click="back" style="width: 16vw; height: 16vw; position: absolute; display: flex; align-items: center; top: 2vw; left: 2vw">
                    <img style="width: 10vw; height: 7.93vw;" src="../assets/back.png" />
                </div>

                <div style="position: absolute; font-size: 18px; font-weight: 500; top: 20vw; left: 6vw;">
                    请选择兑换方式
                </div>


                <div @click="clickBank" class="account_type" style="margin-top: 36vw;">
                    <img @click="setBankAccount" style="width: 10vw; height: 10vw" src="../assets/exchange_bank.png" />
                    <span style="font-size: 18px; font-weight: 500; color: #333; margin-left: 2vw;">银行卡</span>
                    <div style="flex: 1"></div>
                    <span v-if="!hasBankAccount" style="font-size: 16px; color: #666; margin-right: 10vw;">去绑定</span>
                    <img v-if="hasBankAccount && !isBankSelect" style="width: 6vw; height: 6vw; margin-right: 12vw;" src="../assets/unselect.png" />
                    <img v-if="hasBankAccount && isBankSelect" style="width: 6vw; height: 6vw; margin-right: 12vw;" src="../assets/select.png" />
                </div>

                <div @click="clickAli" class="account_type" style="margin-top: 10vw;">
                    <img @click="setAliAccount" style="width: 10vw; height: 10vw" src="../assets/exchange_ali.png" />
                    <span style="font-size: 18px; font-weight: 500; color: #333; margin-left: 2vw;">支付宝</span>
                    <div style="flex: 1"></div>
                    <span v-if="!hasAlipayAccount" style="font-size: 16px; color: #666; margin-right: 10vw;">去绑定</span>
                    <img v-if="hasAlipayAccount && !isAlipaySelect" style="width: 6vw; height: 6vw; margin-right: 12vw;" src="../assets/unselect.png" />
                    <img v-if="hasAlipayAccount && isAlipaySelect" style="width: 6vw; height: 6vw; margin-right: 12vw;" src="../assets/select.png" />
                </div>
            </div>

            <div style="flex: 1"></div>
            <div @click="btnConfirm" style="display: flex; width: 88vw; height: 12vw; background: linear-gradient(to right, #CBACFF, #7384FF); align-self: center; margin-bottom: 10vw; justify-content: center; align-items: center; font-size: 20px; font-weight: 500; color: white; border-radius: 28px;">
                {{ btnTitle }}
            </div>
        </div>

        <div v-if="showPasswordModal" class="modal_password">
            <div @click="hidePasswordModal" style="flex: 1"></div>
            <div style="width: 100vw; height: 60vw; background-color: white; display: flex; flex-direction: column; border-radius: 16px 16px 0 0;">
                <div style="width: 100%; font-size: 16px; color: #666; margin-top: 8vw; text-align: center;">请输入密码</div>
                <input class="input_p" placeholder="6位数字密码" maxlength="6" type="password" v-model="password" />

                <div @click="btnPassword" class="btn_next">确认</div>
                <div @click="forgetPasword" style="position: absolute; top: 74vh; right: 4vw; font-size: 14px; color: #6495ED">
                    忘记密码？
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import axios from 'axios';
import ProfitHelper from '../ProfitHelper';
import { prefix, prefix_dev, userWithdrawStart, userBankMyBank, userBankMyAlipay, userBankGetPassword } from '../url';

export default ({
    data() {
        return {
            urlPrefix: prefix,
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            itemId: '-1',
            hasAlipayAccount: false,
            hasBankAccount: false,
            isPasswordSet: false,
            isAlipaySelect: false,
            isBankSelect: false,

            showPasswordModal: false,
            password: '',
            btnTitle: '立即兑换（¥0.00）'
        };
    },

    created() {
        this.formatUrlParams();
        this.getBankAccount();
        this.getAliAccount();
        this.getPassword();
    },

    methods: {
        formatUrlParams() {
            if (localStorage.getItem('is_dev') == 'yes') {
                this.urlPrefix = prefix_dev;
            }
            this.head.version = localStorage.getItem('version');
            this.head.edition = localStorage.getItem('edition');
            this.head.aps = localStorage.getItem('aps');
            this.head.Authorization = localStorage.getItem('Authorization');
            this.itemId = localStorage.getItem('ITEM_ID');
            this.btnTitle = '立即兑换（¥' + localStorage.getItem('ITEM_ADD_MONEY') + ')';
        },

        back() {
            window.location.href = '/profit-jifen';
        },

        clickBank() {
            if (this.hasBankAccount) {
                this.isBankSelect = !this.isBankSelect;
                this.isAlipaySelect = false;
            } else {
                this.setBankAccount();
            }
        },

        setBankAccount() {
            window.location.href = '/profit-account-bank';
        },

        clickAli() {
            if (this.hasAlipayAccount) {
                this.isAlipaySelect = !this.isAlipaySelect;
                this.isBankSelect = false;
            } else {
                this.setAliAccount();
            }
        },

        setAliAccount() {
            window.location.href = '/profit-account-ali';
        },

        // 获取服务器数据
        getBankAccount() {
            const url = this.urlPrefix + userBankMyBank;
            axios.get(url, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data.account != undefined && data.account.length > 0) {
                    this.hasBankAccount = true;
                    localStorage.setItem('bank_account', data.account);
                    localStorage.setItem('bank_real_name', data.real_name);
                    localStorage.setItem('bank_id_card', data.id_card);
                    localStorage.setItem('bank_phone', data.phone);
                    localStorage.setItem('bank_name', data.bank_name);
                    localStorage.setItem('bank_comment', data.comment);
                }
            })
        },

        getAliAccount() {
            const url = this.urlPrefix + userBankMyAlipay;
            axios.get(url, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data.account != undefined && data.account.length > 0) {
                    this.hasAlipayAccount = true;
                    localStorage.setItem('ali_account', data.account);
                    localStorage.setItem('ali_real_name', data.real_name);
                    localStorage.setItem('ali_id_card', data.id_card);
                    localStorage.setItem('ali_phone', data.phone);
                }
            })
        },

        getPassword() {
            const url = this.urlPrefix + userBankGetPassword;
            axios.get(url, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data.password != undefined && data.password.length > 0) {
                    this.isPasswordSet = true;
                }
            })
        },

        // 兑换按钮 & 输入密码按钮
        btnConfirm() {
            if (!this.isPasswordSet) {
                window.location.href = '/profit-password';
                return;
            } else {
                if (!this.isAlipaySelect && !this.isBankSelect) {
                    alert('请至少选择一种提现方式！')
                    return;
                }
                this.showPasswordModal = true;
            }
        },

        btnPassword() {
            const url = this.urlPrefix + userWithdrawStart;
            let params = {
                id: this.itemId,
                type: this.isBankSelect ? 1 : 2,
                password: this.password,
            };
            params.sign = ProfitHelper.getPostSign(JSON.stringify(params));
            axios.post(url, params, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data == true) {
                    alert('兑换申请已成功提交，请耐心等待');
                    this.back();
                    localStorage.setItem('ITEM_ID', '-1');
                } else {
                    alert(res.data.msg);
                }
            })
        },

        hidePasswordModal() {
            this.showPasswordModal = false;
        },

        forgetPasword() {
            window.location.href = '/profit-password-reset';
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: white;
}
.loading {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: white;
}

.top {
    width: 100vw;
    /* height: 74.6vw; */
    display: flex;
    flex-direction: column;
}
.title {
    position: absolute;
    top: 6vw;
    width: 100%;
    text-align: center;
    font-size: 18px;
}

.account_type {
    display: flex;
    flex-direction: row;
    padding-left: 6vw;
    align-items: center;
    width: 100%;
}

.modal_password {
    position: absolute;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.4);
}
.input_p {
    width: 60vw;
    height: 12vw;
    margin-top: 8vw;
    margin-left: 20vw;
    border: 1px #EEE solid;
    border-radius: 12px;
    text-align: center;
    font-size: 24px;
}
.btn_next {
    display: flex;
    width: 88vw;
    height: 12vw;
    background: linear-gradient(to right, #CBACFF, #7384FF);
    align-self: center;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: white;
    border-radius: 28px;
    margin-top: 6vw;
}
</style>